import { useEffect, useMemo, useState } from 'react';
import MomentUtils from '@date-io/moment';
import { Box, FormControl } from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';
import moment, { Moment } from 'moment';

import { ApiFilterCriteria } from '../../types';
import FilterPopover from './FilterPopover';

interface DateRangeFilterProps {
  field: string;
  name: string;
  onMinDateChange: (date: MaterialUiPickersDate) => void;
  onMaxDateChange: (date: MaterialUiPickersDate) => void;
  criteria: ApiFilterCriteria;
}

const DateRangeFilter = (props: DateRangeFilterProps) => {
  const { criteria } = props;
  const [minDate, setMinDate] = useState<Moment | null>(null);
  const [maxDate, setMaxDate] = useState<Moment | null>(null);
  const [currentCriteria, setCurrentCriteria] =
    useState<ApiFilterCriteria | null>(null);

  const handleMinDateChange = (date: MaterialUiPickersDate) => {
    setMinDate(date ? moment(date.format('YYYY-MM-DD')) : null);
    if (date?.isValid()) {
      props.onMinDateChange(date);
    }
  };
  const handleMaxDateChange = (date: MaterialUiPickersDate) => {
    setMaxDate(date ? moment(date.format('YYYY-MM-DD')) : null);
    if (date?.isValid()) {
      props.onMaxDateChange(date);
    }
  };

  /**
   * Handle initial load.
   */
  useEffect(() => {
    // If the criteria did not change, don't run update.
    if (
      criteria !== null &&
      JSON.stringify(criteria) === JSON.stringify(currentCriteria)
    ) {
      return;
    }

    const filterValueMin = criteria.filters
      ? criteria.filters[`${props.field}Min`]
      : null;
    if (filterValueMin && typeof filterValueMin === 'string') {
      setMinDate(moment(filterValueMin));
    } else {
      setMinDate(null);
    }

    const filterValueMax = criteria.filters
      ? criteria.filters[`${props.field}Max`]
      : null;
    if (filterValueMax && typeof filterValueMax === 'string') {
      setMaxDate(moment(filterValueMax));
    } else {
      setMaxDate(null);
    }

    setCurrentCriteria(criteria);
  }, [criteria]);

  const hasFilters = useMemo(() => {
    return minDate !== null || maxDate !== null;
  }, [minDate, maxDate]);

  return (
    <FilterPopover name={props.name} hasFilters={hasFilters}>
      <Box pl={2} pr={2}>
        <FormControl>
          <Box>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                disableToolbar
                format="DD-MM-YYYY"
                orientation="landscape"
                autoOk
                margin="normal"
                label="Datum van"
                value={minDate}
                onChange={handleMinDateChange}
                KeyboardButtonProps={{
                  'aria-label': 'Verander datum',
                }}
              />
            </MuiPickersUtilsProvider>
          </Box>
        </FormControl>
        <Box>
          <FormControl>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <KeyboardDatePicker
                disableToolbar
                format="DD-MM-YYYY"
                orientation="landscape"
                autoOk
                margin="normal"
                label="Datum tot"
                value={maxDate}
                onChange={handleMaxDateChange}
                KeyboardButtonProps={{
                  'aria-label': 'Verander datum',
                }}
              />
            </MuiPickersUtilsProvider>
          </FormControl>
        </Box>
      </Box>
    </FilterPopover>
  );
};

export default DateRangeFilter;
